import { print, stripIgnoredCharacters } from "graphql";
export function normalizeQuery(query) {
  if (typeof query === "string") {
    return query;
  }
  if (query && query.kind) {
    return stripIgnoredCharacters(print(query));
  }
  return null;
}
